module.exports = __webpack_public_path__ + "media/profile_pictures/profile-picture-5-fff93226.jpg";